import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"
import MarketingLayout from "@/components/marketing/MarketingLayout"
import { useBlogPosts } from "@/lib/blog"
import { useBrand } from "@/hooks/use-brand"
import { LOCALE_CONFIG } from "@/config/locale-domains"

export default function BlogIndex() {
  const { t } = useTranslation()
  const posts = useBlogPosts()
  const brand = useBrand()
  const domain = LOCALE_CONFIG[brand.locale]?.domain || LOCALE_CONFIG.ro.domain

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Blog",
    name: t("pages.blog.title"),
    url: `https://${domain}/blog`,
    blogPost: posts.map((p) => ({
      "@type": "BlogPosting",
      headline: p.title,
      url: `https://${domain}/blog/${p.slug}`,
      datePublished: p.date,
    })),
  }

  return (
    <MarketingLayout seoKey="blog" jsonLd={jsonLd}>
      <div className="pt-36 pb-24">
        <div className="mx-auto max-w-3xl px-6 lg:px-10">
          <p className="text-xs tracking-[0.2em] uppercase font-semibold text-muted-foreground mb-5">
            {t("pages.blog.eyebrow")}
          </p>
          <h1 className="font-display text-4xl md:text-5xl tracking-tighter font-medium">{t("pages.blog.title")}</h1>
          <p className="mt-6 text-lg text-muted-foreground">{t("pages.blog.subtitle")}</p>
        </div>

        <div className="mx-auto max-w-3xl px-6 lg:px-10 mt-14 space-y-8">
          {posts.length === 0 && (
            <p className="text-muted-foreground">{t("pages.blog.empty")}</p>
          )}
          {posts.map((post) => (
            <article key={post.slug} className="border-b border-border pb-8">
              <time className="text-xs text-muted-foreground" dateTime={post.date}>
                {post.date}
              </time>
              <h2 className="font-display text-2xl tracking-tight font-medium mt-2">
                <Link to={`/blog/${post.slug}`} className="hover:text-accent transition-colors">
                  {post.title}
                </Link>
              </h2>
              <p className="mt-2 text-muted-foreground">{post.description}</p>
              <Link
                to={`/blog/${post.slug}`}
                className="inline-block mt-3 text-sm font-medium text-accent hover:underline"
              >
                {t("pages.blog.readMore")}
              </Link>
            </article>
          ))}
        </div>
      </div>
    </MarketingLayout>
  )
}
